import { Injectable, Injector } from '@angular/core';
import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Router } from '@angular/router';
import { MatDialog } from '@angular/material/dialog';
import { Observable, EMPTY, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { RestEndpoint } from '../constants/rest-endpoint.constants';
import { SnackBarTheme } from '../shared/models/snackbar-theme.enum';
import { AccountService } from '../shared/services/account/account.services';
import { TranslationConstants } from '../shared/services/util/translation.constants';
import { SnackbarComponent } from '../shared/snackbar/snackbar.component';

@Injectable()
export class ErrorInterceptor implements HttpInterceptor {
    private lastSessionExpiredLogoutAt = 0;

    constructor(
        private readonly injector: Injector
    ) { }

    public intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        return next.handle(request).pipe(
            catchError((err: HttpErrorResponse) => {
                const accountService = this.injector.get(AccountService);

                if (
                    this.isSessionExpiredException(err) &&
                    request.url !== RestEndpoint.destroySession &&
                    accountService.hasStoredLoggedUser()
                ) {
                    if (!this.hasRecentSessionExpirationLogout()) {
                        this.lastSessionExpiredLogoutAt = Date.now();
                        this.injector.get(MatDialog).closeAll();
                        this.injector.get(SnackbarComponent).openSnackBar(
                            this.injector.get(TranslationConstants).translate('common.sessionExpired'),
                            SnackBarTheme.error,
                            5000
                        );
                        accountService.logout();
                        void this.injector.get(Router).navigateByUrl('/account/login');
                    }

                    return EMPTY;
                }

                return throwError(err);
            })
        );
    }

    private isSessionExpiredException(err: HttpErrorResponse): boolean {
        return err?.error?.message === 'User session has expired.';
    }

    private hasRecentSessionExpirationLogout(): boolean {
        return Date.now() - this.lastSessionExpiredLogoutAt < 1000;
    }
}
